import React from 'react'
import { Link } from "react-router-dom"
import { Helmet } from "react-helmet"
import axios from "axios"
import { ReactComponent as Arrow } from "../assets/arrow.svg"

import Title from "../components/global/Title/Title"
import Content from "../components/global/Content/Content"
import Animation from "../components/global/Animation/Animation"

import { Loader } from "../components/common/Loader/Loader"

export default class InternationalScreen extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      loading: false,
      error: '',
      data: [],
    }
  }

  componentDidMount() {
    this.loadData()
  }

  loadData = () => {
    this.setState({loading: true})

    axios.get(`/wp-json/wp/v2/pages/115`)
      .then( res => {
        this.setState({ data: res.data, loading: false })
      })
      .catch(error => { console.log(error) })
  }

  render() {
    const { data, loading } = this.state
    return (
      loading === true ? <Loader/> :
      <div>
        <Helmet>
          <title>{data.yoast_title && data.yoast_title}</title>
          <meta name={data.yoast_meta && data.yoast_meta[0].name} content={data.yoast_meta && data.yoast_meta[0].content} />
        </Helmet>
        <section className="relative p-0 pt-16">
          <Animation/>
          <div className="max-w-screen-xl mx-auto px-4 sm:px-6 md:flex md:flex-wrap lg:px-8 z-10 relative">
            <div className="ml-1-col w-3/4 py-32">
              <div className="breadcrumb-bar" style={{color: "#F58120"}}>
                <div className="breadcrumb"><Link to="/">Home</Link><div className="px-2 breadcrumb-seperator"><Arrow/></div></div>
                <div className="breadcrumb" style={{color: "#000"}}>Internationaal</div>
              </div>
              <Title level="1" className="underlined">Internationaal</Title>
              <Content className="mt-10 xs:w-full w-2/3">{ data.content && data.content.rendered }</Content>
            </div>
            <div className="w-full overflow-y-auto">
              <table className="w-3/4 ml-1-col mx-auto table-auto border border-collapse rounded-lg overflow-hidden my-16">
                <tbody>
                {data && data.acf && data.acf.websites.map((prop, key) => {
                  return (
                    <tr key={key} className="border-b border-orange">
                      <td className="px-4 py-2">{prop.country}</td>
                      <td className="px-4 py-2">{prop.district}</td>
                      <td className="px-4 py-2 float-right"><a href={prop.website.url} target="_blank" rel="noopener noreferrer">{prop.website.title}</a></td>
                    </tr>
                  )
                })}
                </tbody>
              </table>
            </div>
          </div>
        </section>
      </div>
    )
  }
}
